<div class="p-field w-full mb-2" [ngClass]="options.containerClass">
  <label class="mb-2"
    >{{ options.label | translate }}
    <span
      *ngIf="options?.validators?.required"
      [pTooltip]="'BUTTONS.required' | translate"
      tooltipPosition="top"
      class="text-pink-500"
      >*</span
    >
  </label>
  <textarea
    [rows]="options.rows"
    [cols]="options.cols"
    [placeholder]="options.placeholder ?? ''"
    [formControlName]="options.formControlName"
    pInputTextarea
  ></textarea>

  <app-field-errors [errors]="errors"></app-field-errors>
</div>
